<template>
  <div class="ad-list-contact-us">
    <GeetestCaptcha
      ref="ContactUsCaptchaInstance"
      :current-url-name="geetestUrlName"
      @captchaVerifyCallbackGeetest="finishContactUsSlideGeetest"
    />
    <ContactUsDrawer
      :show="showContactUsModal"
      :form-data="contactUsForm"
      :reason-options="contactUsReasonOptions"
      :country-options="contactUsCountryOptions"
      :loading="contactUsLoading"
      :submitting="contactUsSubmitting"
      :hide-button="true"
      :simple="true"
      @update:formData="handleContactUsFormUpdate"
      @submit="handleContactUsSubmit"
      @close="closeContactUsModal"
    />
    <ContactUsSuccessModal
      :show="showContactUsSuccessModal"
      @close="closeContactUsSuccessModal"
    />
  </div>
</template>

<script>
import GeetestCaptcha from '../../components/GeetestCaptcha.vue';
import ContactUsDrawer from '../../components/new-login/ContactUs/ContactUsDrawer.vue';
import ContactUsSuccessModal from '../../components/new-login/ContactUs/ContactUsSuccessModal.vue';
import { AlertDialog } from '../../_helpers/AlertDialog';
import { userService, CompanyInfoService } from '../../_services';
import { getContactUsConfig, DEFAULT_LANG_ID } from '../../components/new-login/Common/new-login-config.js';

const REASON_CONFIG = [
  { value: 1, text: '我需要协助,请联系我。', langid: 936 },
  { value: 1, text: '我需要協助,請聯繫我。', langid: 950 },
  { value: 1, text: 'I need assistance. Please contact me.', langid: 1252 },
  { value: 2, text: '我想更改主帐号的密码，请联系我。', langid: 936 },
  { value: 2, text: '我想更改主帳號的密碼，請聯繫我。', langid: 950 },
  { value: 2, text: 'I want to update the password of the master account. Please contact me.', langid: 1252 },
];

function currentLangId() {
  return parseInt(localStorage.getItem('currentLangId')) || DEFAULT_LANG_ID;
}

function defaultReasonText(langId) {
  if (langId === 936) return '我需要协助,请联系我。';
  if (langId === 950) return '我需要協助,請聯繫我。';
  return 'I need assistance. Please contact me.';
}

function createForm() {
  const langId = currentLangId();
  const cfg = getContactUsConfig('supplier');
  return {
    fid: cfg.fid,
    hidCodepage: String(langId),
    showid: cfg.showid,
    showcode: cfg.showcode,
    langid: langId,
    Reason: 1,
    ReasonText: defaultReasonText(langId),
    message: '',
    name: '',
    Company: '',
    Country: '',
    CountryText: '',
    Mobile: '',
    Email: '',
    hdPrivacy: false,
    hdShare: true,
    captchaVerifyParam: '',
    submitPageURL: 'AdInfoCenterContactUs',
    IsNewValidCode: 'true',
    isNotNeedValidate: 'false',
  };
}

export default {
  name: 'AdListContactUs',
  components: { GeetestCaptcha, ContactUsDrawer, ContactUsSuccessModal },
  mixins: [AlertDialog],
  props: {
    submitPageURL: {
      type: String,
      default: 'AdInfoCenterContactUs',
    },
  },
  data() {
    return {
      showContactUsModal: false,
      showContactUsSuccessModal: false,
      contactUsLoading: false,
      contactUsSubmitting: false,
      contactUsReasonOptions: [],
      contactUsCountryOptions: [],
      companyCountryOptions: [],
      loginInfo: null,
      companyInfo: null,
      currentUserAccount: null,
      contactUsForm: createForm(),
    };
  },
  created() {
    if (this.submitPageURL) {
      this.contactUsForm.submitPageURL = this.submitPageURL;
    }
  },
  computed: {
    geetestUrlName() {
      if (process.env.VUE_APP_EMP_ENV_NAME === 'UAT') return 'eMarketplaceUat_Back';
      if (process.env.VUE_APP_EMP_ENV_NAME === 'AI') return 'eMarketplaceAi_Back';
      return 'eMarketplace_Back';
    },
    isLoggedIn() {
      return !!this.$store?.state?.authentication?.user;
    },
  },
  methods: {
    open() {
      return this.openContactUsModal();
    },
    async openContactUsModal() {
      if (this.submitPageURL) {
        this.contactUsForm.submitPageURL = this.submitPageURL;
      }
      this.showContactUsModal = true;
      if (this.contactUsReasonOptions.length === 0) {
        this.loadContactUsReasons();
      }
      if (!this.contactUsForm.Reason) {
        const langId = this.contactUsForm.langid || currentLangId();
        this.contactUsForm.Reason = 1;
        this.contactUsForm.ReasonText = defaultReasonText(langId);
      }
      if (!this.loginInfo) {
        await this.GetLoginInfo();
      }
      if (!this.currentUserAccount) {
        await this.GetCurrentUserAccount();
      }
      if (!this.companyInfo) {
        await this.GetCompanyInfo();
      }
      if (!this.companyCountryOptions.length) {
        await this.loadCompanyCountryOptions();
      }
      await this.fillUserInfoToForm();
    },
    closeContactUsModal() {
      this.showContactUsModal = false;
    },
    closeContactUsSuccessModal() {
      this.showContactUsSuccessModal = false;
    },
    loadContactUsReasons() {
      const langId = this.contactUsForm.langid || currentLangId();
      this.contactUsReasonOptions = REASON_CONFIG.filter((item) => item.langid === langId);
    },
    handleContactUsFormUpdate(newFormData) {
      this.contactUsForm = { ...this.contactUsForm, ...newFormData };
      if (newFormData.Reason !== undefined) {
        const selected = this.contactUsReasonOptions.find((r) => r.value === newFormData.Reason);
        this.contactUsForm.ReasonText = selected ? selected.text : '';
      }
    },
    async handleContactUsSubmit() {
      const form = document.getElementById('cu-form-contact-us');
      if (!form) {
        this.$Alert(0, this.$t('lbl_EMPBE_Save_Failed_HasError', { msg: 'Form not found' }));
        return;
      }
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      await this.fillUserInfoToForm();
      this.contactUsSubmitting = true;
      this.contactUsLoading = true;
      await this.$nextTick();
      await this.doSubmitContactUs();
    },
    async finishContactUsSlideGeetest(captchaVerifyParam, resolve) {
      this.contactUsForm.captchaVerifyParam = JSON.stringify(captchaVerifyParam || {});
      if (captchaVerifyParam) {
        const fields = {
          'cu-lot-number': captchaVerifyParam.lot_number || '',
          'cu-captcha-output': captchaVerifyParam.captcha_output || '',
          'cu-pass-token': captchaVerifyParam.pass_token || '',
          'cu-gen-time': captchaVerifyParam.gen_time || '',
          'cu-type-name': 'CPS_Login',
        };
        Object.keys(fields).forEach((id) => {
          const el = document.getElementById(id);
          if (el) el.value = fields[id];
        });
      }
      if (resolve) resolve(true);
      await this.doSubmitContactUs();
    },
    async doSubmitContactUs() {
      try {
        const form = document.getElementById('cu-form-contact-us');
        if (!form) {
          this.$Alert(0, this.$t('lbl_EMPBE_Save_Failed_HasError', { msg: 'Form not found' }));
          return;
        }
        const {
          sendFormEmail,
          getEmailProjectByReason,
          getEmailConfigFromDatabase,
        } = await import('../../components/new-login/Common/email-sender.js');
        const {
          SUBMIT_STATUS_CODE,
          DEFAULT_SHOW_ID,
          DEFAULT_SHOW_CODE,
          getCurrentLangId,
        } = await import('../../components/new-login/Common/new-login-config.js');

        const reason = this.contactUsForm.Reason;
        const showId = this.contactUsForm.showid || DEFAULT_SHOW_ID;
        const langId = this.contactUsForm.langid || getCurrentLangId();
        const showCode = this.contactUsForm.showcode || DEFAULT_SHOW_CODE;
        const dbEmailConfig = await getEmailConfigFromDatabase(
          showId,
          langId,
          getEmailProjectByReason(reason),
          showCode,
        );
        if (!this.companyInfo) {
          await this.GetCompanyInfo();
        }
        if (!this.companyCountryOptions.length) {
          await this.loadCompanyCountryOptions();
        }
        const userInfo = this.getCompleteUserInfo();
        await this.fillUserInfoToForm();
        const ticketEl = document.getElementById('cu-captcha-ticket');
        const randstrEl = document.getElementById('cu-captcha-randstr');
        const currentLangId = parseInt(langId);
        const formDataToSend = {
          fid: this.contactUsForm.fid || '',
          showid: showId,
          showcode: showCode,
          langid: langId,
          hidCodepage: this.contactUsForm.hidCodepage || String(langId),
          submitPageURL: this.contactUsForm.submitPageURL || 'AdInfoCenterContactUs',
          IsNewValidCode: this.contactUsForm.IsNewValidCode || 'true',
          isNotNeedValidate: this.isLoggedIn ? 'true' : (this.contactUsForm.isNotNeedValidate || 'false'),
          captchaVerifyParam: typeof this.contactUsForm.captchaVerifyParam === 'string'
            ? this.contactUsForm.captchaVerifyParam
            : JSON.stringify(this.contactUsForm.captchaVerifyParam || {}),
          Reason: reason,
          ReasonText: this.contactUsForm.ReasonText || '',
          message: this.contactUsForm.message || '',
          name: this.contactUsForm.name || this.getUserField(userInfo, 'name', currentLangId) || '',
          Company: this.contactUsForm.Company || this.getUserField(userInfo, 'company', currentLangId) || '',
          Country: this.contactUsForm.Country || '',
          CountryText: this.contactUsForm.CountryText || this.contactUsForm.Country || '',
          Mobile: this.contactUsForm.Mobile || this.getUserField(userInfo, 'mobile', currentLangId) || '',
          Email: this.contactUsForm.Email || this.getUserField(userInfo, 'email', currentLangId) || '',
          hdPrivacy: this.contactUsForm.hdPrivacy ? 'true' : 'false',
          hdShare: this.contactUsForm.hdShare ? 'true' : 'false',
          captcha_ticket: ticketEl ? ticketEl.value : '',
          captcha_randstr: randstrEl ? randstrEl.value : '',
        };
        const result = await sendFormEmail({
          formData: formDataToSend,
          captchaData: null,
          emailConfig: {
            email_to: this.contactUsForm.Email || '',
            email_from: dbEmailConfig.FromEmail || 'emarketplace@adsale.com.hk',
            email_fromName: dbEmailConfig.FromName || '',
            email_replyTo: dbEmailConfig.ReplyTo || '',
            email_bcc: dbEmailConfig.BCC || '',
            email_cc: dbEmailConfig.CC || '',
            email_subject: dbEmailConfig.Title || 'eMarketplace - Contact Us',
            email_confirm_message: 'Send form Success',
          },
          formType: 'contact-us',
        });
        if (result && result.statusCode === SUBMIT_STATUS_CODE.SUCCESS) {
          this.closeContactUsModal();
          this.showContactUsSuccessModal = true;
          this.resetContactUsForm();
        } else if (result && result.statusCode === SUBMIT_STATUS_CODE.CAPTCHA_FAILED) {
          this.$Alert(0, this.$t('lbl_EMPBE_Save_Failed_HasError', { msg: '验证码验证失败，请重试' }));
        } else if (result && result.statusCode === SUBMIT_STATUS_CODE.VALIDATION_ERROR) {
          const msg = result.Msg && result.Msg.length > 0 ? result.Msg.join(', ') : '数据验证失败';
          this.$Alert(0, this.$t('lbl_EMPBE_Save_Failed_HasError', { msg: `以下数据不能为空: ${msg}` }));
        } else {
          const errorMsg = result?.Msg
            ? (Array.isArray(result.Msg) ? result.Msg.join(', ') : result.Msg)
            : (result?.error || 'Unknown error');
          this.$Alert(0, this.$t('lbl_EMPBE_Save_Failed_HasError', { msg: errorMsg }));
        }
      } catch (error) {
        this.$Alert(0, this.$t('lbl_EMPBE_Save_Failed_HasError', { msg: error.message || 'Submit failed' }));
      } finally {
        this.contactUsSubmitting = false;
        this.contactUsLoading = false;
      }
    },
    resetContactUsForm() {
      const langId = this.contactUsForm.langid || currentLangId();
      this.contactUsForm = {
        ...createForm(),
        langid: langId,
        hidCodepage: String(langId),
        Reason: 1,
        ReasonText: defaultReasonText(langId),
      };
    },
    async GetLoginInfo() {
      try {
        const res = await userService.GetLoginInfo();
        if (Array.isArray(res)) this.loginInfo = res;
      } catch (e) {
        // silent
      }
    },
    async GetCurrentUserAccount() {
      try {
        const res = await userService.GetUserMyAccount();
        if (res?.data) this.currentUserAccount = res.data;
      } catch (e) {
        // silent
      }
    },
    async GetCompanyInfo() {
      try {
        const user = this.$store?.state?.authentication?.user;
        if (!user?.empCompanyId) return;
        const res = await CompanyInfoService.GetCompanyInfoAsync({ companyId: user.empCompanyId });
        if (res?.isSuccessful && res.data) this.companyInfo = res.data;
      } catch (e) {
        // silent
      }
    },
    async loadCompanyCountryOptions() {
      try {
        const res = await CompanyInfoService.GetCountryList();
        if (res && res.isSuccessful && Array.isArray(res.data)) {
          this.companyCountryOptions = res.data;
        }
      } catch (e) {
        this.companyCountryOptions = [];
      }
    },
    async fillUserInfoToForm() {
      const langId = parseInt(this.contactUsForm.langid || currentLangId());
      const userInfo = this.getCompleteUserInfo();
      const user = this.$store?.state?.authentication?.user || {};
      let role = String(user.userRole || '').toUpperCase();
      let accountUserId = user.accountUserId ?? user.AccountUserId;
      if (user.token && !String(user.token).startsWith('test-token-')) {
        try {
          const payload = JSON.parse(atob(String(user.token).split('.')[1]));
          if (!role) role = String(payload.userRole || '').toUpperCase();
          if (accountUserId === undefined || accountUserId === null) {
            accountUserId = payload.accountUserId;
          }
        } catch (e) { /* ignore */ }
      }
      if (role === 'ROOT' || Number(accountUserId) === 0) {
        const note = this.$t('EMP_UserSetting_ContactUs_MasterLoginNote');
        this.contactUsForm.Email = note;
        this.contactUsForm.Mobile = note;
        this.contactUsForm.Country = note;
        this.contactUsForm.CountryText = note;
        this.contactUsForm.name = user.login || user.Login || '';
        return;
      }
      if (!userInfo || Object.keys(userInfo).length === 0) return;
      if (!this.contactUsForm.name) {
        const name = this.getUserField(userInfo, 'name', langId);
        if (name) this.contactUsForm.name = name;
      }
      if (!this.contactUsForm.Email) {
        const email = this.getUserField(userInfo, 'email', langId);
        if (email) this.contactUsForm.Email = email;
      }
      if (!this.contactUsForm.Company) {
        const company = this.getUserField(userInfo, 'company', langId);
        if (company) this.contactUsForm.Company = company;
      }
      if (!this.contactUsForm.Mobile) {
        const mobile = this.getUserField(userInfo, 'mobile', langId);
        if (mobile) this.contactUsForm.Mobile = mobile;
      }
      if (!this.contactUsForm.CountryText) {
        const countryName = this.resolveContactUsCountryName(userInfo);
        if (countryName) {
          this.contactUsForm.Country = countryName;
          this.contactUsForm.CountryText = countryName;
        }
      }
    },
    resolveContactUsCountryName(userInfo) {
      const emp = (this.companyInfo && (this.companyInfo.companyEmp || this.companyInfo.CompanyEmp)) || {};
      const candidates = [
        emp.countryId, emp.CountryId,
        userInfo && userInfo.countryId, userInfo && userInfo.CountryId,
        this.$store?.state?.authentication?.user?.countryId,
      ];
      const countryId = candidates.find((id) => id !== undefined && id !== null && String(id) !== '' && Number(id) !== 0);
      if (!countryId || !this.companyCountryOptions.length) return '';
      const hit = this.companyCountryOptions.find((c) => String(c.id) === String(countryId));
      return hit && hit.label ? hit.label : '';
    },
    getUserField(userInfo, field, langId) {
      if (!userInfo) return '';
      if (field === 'name') {
        if (langId === 1252 && userInfo.personNameEn) return userInfo.personNameEn;
        if (langId === 950 && userInfo.personNameTc) return userInfo.personNameTc;
        if (langId === 936 && userInfo.personNameSc) return userInfo.personNameSc;
        return userInfo.personNameEn || userInfo.personNameTc || userInfo.personNameSc
          || userInfo.personName || userInfo.name || '';
      }
      if (field === 'company') {
        if (langId === 1252 && userInfo.companyNameEn) return userInfo.companyNameEn;
        if (langId === 950 && userInfo.companyNameTc) return userInfo.companyNameTc;
        if (langId === 936 && userInfo.companyNameSc) return userInfo.companyNameSc;
        return userInfo.companyNameEn || userInfo.companyNameTc || userInfo.companyNameSc || userInfo.company || '';
      }
      if (field === 'email') return userInfo.emailValue || userInfo.email || '';
      if (field === 'mobile') return userInfo.phoneValue || userInfo.mobile || userInfo.phone || '';
      if (field === 'country') return userInfo.countryCode || userInfo.country || userInfo.countryId || '';
      return '';
    },
    getCompleteUserInfo() {
      let userInfo = this.currentUserAccount ? { ...this.currentUserAccount } : {};
      const storeUser = this.$store?.state?.authentication?.user;
      if (storeUser) userInfo = { ...userInfo, ...storeUser };
      if (Array.isArray(this.loginInfo)) {
        this.loginInfo.forEach((item) => {
          if (item.type === 'email' && item.verifyLogin) {
            userInfo.emailValue = item.verifyLogin;
            userInfo.email = item.verifyLogin;
          } else if (item.type === 'mobile' && item.verifyLogin) {
            userInfo.phoneValue = item.verifyLogin;
            userInfo.mobile = item.verifyLogin;
          }
        });
      }
      if (this.companyInfo?.companyEmp) {
        const emp = this.companyInfo.companyEmp;
        userInfo.companyNameEn = userInfo.companyNameEn || emp.nameEng || emp.nameE;
        userInfo.companyNameTc = userInfo.companyNameTc || emp.nameTrad || emp.nameT;
        userInfo.companyNameSc = userInfo.companyNameSc || emp.nameSimp || emp.nameS;
      }
      return userInfo;
    },
  },
};
</script>
